
import React, { 
  useState, 
  useEffect,
  useRef
} from 'react'
import parse from 'parser/parse-html'
import { useContent } from 'data/hooks'
import { LoadingIndicator } from 'basecomps'

export default props => {

  const contentRef = useRef() 

  const { 
    title, 
    content, 
    blocks 
  } = useContent(window.playmotiv.pageslug)

  const [ parsedcontent, setParsedcontent ] = useState()  
  
  useEffect(() => {

    setTimeout(() => {

      setParsedcontent(
        parse(content)
      )
      
    }, 100)

  }, [content])

  return<div
    ref={ contentRef } 
    className="content"
  >
    { 
      parsedcontent ?
      parsedcontent
      : 
      <LoadingIndicator text="Cargando ..." />
    }
  </div>
}